<template>
    <item-edit-view v-slot:default="_">
        <assignment-edit-form
                :disabled="_.itemDisabled"
                v-model="_.item"
        />
    </item-edit-view>
</template>

<script>
    import ItemEditView from '../../Item/Views/ItemEditView'
    import AssignmentEditForm from './Shared/AssignmentEditForm'

    export default {
        name: 'AssignmentsEditPage',
        components: {
            ItemEditView,
            AssignmentEditForm,
        },
    }
</script>

<style scoped>

</style>